export default __webpack_public_path__ + "static/media/custom_image_1.f1562bec.png";